const PORTAL_BRANDS = {
  bankari: {
    key: "bankari",
    name: "Bankári",
    eyebrow: "Klientsky portál",
    projectName: "Vaša nehnuteľnosť",
    supportEmail: "info@bankari.sk",
    accent: "#2d7dd2",
    accentStrong: "#1f67b3",
    accentSoft: "#eaf3fd",
    surfaceTint: "#f6f9fc",
    ink: "#152033",
  },
  urbo: {
    key: "urbo",
    name: "URBO",
    eyebrow: "Klientsky portál",
    projectName: "TheUpside",
    supportEmail: "info@urbo.sk",
    accent: "#b8cf63",
    accentStrong: "#8da63c",
    accentSoft: "#f1f6df",
    surfaceTint: "#f7f8f3",
    ink: "#1a2118",
  },
};

const BRAND_HOSTS = {
  urbo: ["urbo.sk"],
  bankari: ["bankari.sk"],
};

function queryBrand() {
  if (typeof window === "undefined") return null;

  const params = new URLSearchParams(window.location.search);
  const brand = params.get("brand") || params.get("portal");
  return PORTAL_BRANDS[brand] ? brand : null;
}

function brandFromHostname(hostname) {
  const normalizedHostname = (hostname || "").toLowerCase();

  return Object.entries(BRAND_HOSTS).find(([, domains]) => {
    return domains.some(
      (domain) =>
        normalizedHostname === domain || normalizedHostname.endsWith(`.${domain}`),
    );
  })?.[0];
}

export function resolvePortalBrand() {
  const previewBrand = queryBrand();
  if (previewBrand && typeof window !== "undefined") {
    window.sessionStorage.setItem("portal-brand-preview", previewBrand);
    return PORTAL_BRANDS[previewBrand];
  }

  const configuredBrand = process.env.VUE_APP_PORTAL_BRAND;
  if (PORTAL_BRANDS[configuredBrand]) return PORTAL_BRANDS[configuredBrand];

  if (typeof window !== "undefined") {
    const hostnameBrand = brandFromHostname(window.location.hostname);
    if (hostnameBrand) return PORTAL_BRANDS[hostnameBrand];

    const preview = window.sessionStorage.getItem("portal-brand-preview");
    if (PORTAL_BRANDS[preview]) return PORTAL_BRANDS[preview];
  }

  return PORTAL_BRANDS.bankari;
}

export function applyPortalBrand(brand = resolvePortalBrand()) {
  if (typeof document === "undefined") return brand;

  const root = document.documentElement;
  root.dataset.portalBrand = brand.key;
  root.style.setProperty("--portal-accent", brand.accent);
  root.style.setProperty("--portal-accent-strong", brand.accentStrong);
  root.style.setProperty("--portal-accent-soft", brand.accentSoft);
  root.style.setProperty("--portal-surface-tint", brand.surfaceTint);
  root.style.setProperty("--portal-ink", brand.ink);

  document.title = `${brand.eyebrow} | ${brand.name}`;
  document
    .querySelector('meta[name="theme-color"]')
    ?.setAttribute("content", brand.accent);

  return brand;
}

export function resolveApiBaseUrl() {
  if (process.env.VUE_APP_API_BASE_URL) return process.env.VUE_APP_API_BASE_URL;

  if (typeof window !== "undefined" && window.location.hostname.endsWith("urbo.sk")) {
    return process.env.VUE_APP_URBO_API_BASE_URL || "https://apire.bankari.sk/";
  }

  return process.env.VUE_APP_BANKARI_API_BASE_URL || "https://apire.bankari.sk/";
}

export { PORTAL_BRANDS };
